import { Injectable } from '@angular/core';

import { InstaStoryImageryItemBootstrapService } from '../insta-story-imagery-item/insta-story-imagery-item-bootstrap.service';
import { PromoOptinInstaStoryItemBootstrapService } from '../promo-optin-insta-storyitem/promo-optin-insta-story-item-bootstrap.service';

@Injectable({
    providedIn: 'root',
})
export class OnAppInitHandler {
    constructor(
        private promoOptinInstaStoryItemBootstrapService: PromoOptinInstaStoryItemBootstrapService,
        private instaStoryImageryItemBootstrapService: InstaStoryImageryItemBootstrapService,
    ) {}

    execute() {
        this.promoOptinInstaStoryItemBootstrapService.onAppInit();
        this.instaStoryImageryItemBootstrapService.onAppInit();
    }
}
